import React from "react";
import { Detail } from "../../../StyledComponents";
import {
  TimelineChangeList,
  TimelineChangeRow,
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const formatTargetValue = (detail, value) => {
  if (detail.field.includes('Rate')) {
    return `${value.toLocaleString("en-US", {maximumFractionDigits: 2, minimumFractionDigits: 2})}%`
  }

  if (detail.field.includes('Term')) {
    return `${value.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} years`
  }

  return `$${value.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}`
}

const TargetsUpdated = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">updated by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    <TimelineSection>
      <TimelineSectionTitle>Updated Refinance Targets</TimelineSectionTitle>
      <TimelineChangeList>
        {milestone.details.map((detail) => (
          <TimelineChangeRow key={detail.field}>
            <span className="timeline-change-label">{detail.field}:</span>
            <span className="timeline-change-value">
              {detail.old === detail.new ?
                formatTargetValue(detail, detail.new)
              :
                `${formatTargetValue(detail, detail.old)} to ${formatTargetValue(detail, detail.new)}`
              }
            </span>
          </TimelineChangeRow>
        ))}
      </TimelineChangeList>
    </TimelineSection>
    <TimelineSection>
      <TimelineSectionTitle>Changes in Potential Outcomes</TimelineSectionTitle>
      <TimelineChangeList>
        <TimelineChangeRow>
          <span className="timeline-change-label">Interest Owed:</span>
          <span className="timeline-change-value">
            ${milestone.newProfits.profitNumber.old.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} to ${milestone.newProfits.profitNumber.new.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}
            <span className="timeline-change-delta">
              {milestone.newProfits.profitNumber.difference === 0 ?
                <Detail className="wrappedGray">no change</Detail>
              : milestone.newProfits.profitNumber.new > milestone.newProfits.profitNumber.old ?
                <Detail className="wrapped">${milestone.newProfits.profitNumber.difference.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} increase</Detail>
              :
                <Detail className="wrappedRed">${milestone.newProfits.profitNumber.difference.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} decrease</Detail>
              }
            </span>
          </span>
        </TimelineChangeRow>
        <TimelineChangeRow>
          <span className="timeline-change-label">Revenue:</span>
          <span className="timeline-change-value">
            ${milestone.newProfits.profitPercent.old.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} to ${milestone.newProfits.profitPercent.new.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}
            <span className="timeline-change-delta">
              {milestone.newProfits.profitPercent.difference === 0 ?
                <Detail className="wrappedGray">no change</Detail>
              : milestone.newProfits.profitPercent.new > milestone.newProfits.profitPercent.old ?
                <Detail className="wrapped">{milestone.newProfits.profitPercent.difference.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}% increase</Detail>
              :
                <Detail className="wrappedRed">{milestone.newProfits.profitPercent.difference.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}% decrease</Detail>
              }
            </span>
          </span>
        </TimelineChangeRow>
        <TimelineChangeRow>
          <span className="timeline-change-label">Monthly Payments:</span>
          <span className="timeline-change-value">
            ${milestone.newProfits.monthlyPayments.old.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} to ${milestone.newProfits.monthlyPayments.new.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}
            <span className="timeline-change-delta">
              {milestone.newProfits.monthlyPayments.difference === 0 ?
                <Detail className="wrappedGray">no change</Detail>
              : milestone.newProfits.monthlyPayments.new > milestone.newProfits.monthlyPayments.old ?
                <Detail className="wrapped">${milestone.newProfits.monthlyPayments.difference.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} increase</Detail>
              :
                <Detail className="wrappedRed">${milestone.newProfits.monthlyPayments.difference.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} decrease</Detail>
              }
            </span>
          </span>
        </TimelineChangeRow>
      </TimelineChangeList>
    </TimelineSection>
  </TimelineContent>
)

export default TargetsUpdated
